import { Box, List, Typography } from "@mui/material"
import { If } from "lib/@components/if"
import { Repeat } from "lib/@components/repeat"
import { ChangeLegislationListItem } from "./change-legislation-list-item"

export function ChangeLegislationList({ legislation }) {
    return (
        <If truthy={legislation?.length}>
            <Box>
                <Typography variant="caption" color="text.secondary" display="block" mb={0.5}>
                    Referenced legislation
                </Typography>
                <List dense disablePadding>
                    <Repeat list={legislation} item={<ChangeLegislationListItem />} keyFn={keyById} />
                </List>
            </Box>
        </If>
    )

    function keyById(leg) {
        return leg.id ?? leg.url ?? leg.ref
    }
}
